<template>
  <div v-if="status === 'ready'" id="app">
    <router-view />
  </div>

  <loading v-else-if="status === 'loading'" />

  <cannot-start v-else-if="status === 'error'" :error="error" />
</template>

<script>
import { mapGetters } from 'vuex'
import { isEmpty } from 'lodash-es'

import Loading from '@/components/layout/Loading'
import CannotStart from '@/components/page/errors/CannotStart'

export default {
  name: 'App',

  components: { Loading, CannotStart },

  data () {
    return {
      status: 'loading',
      error: ''
    }
  },

  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(['application'])
  },

  /** Application initialization
   * - starts by a getApplication
   * - then, check the version is compatible
   */
  async mounted () {
    // If authenticated, set clientHTTP header
    if (this.$api.isAuthenticated()) {
      this.$api.setHeader()
    }

    // Delay init requests by 500ms to let chunck to load
    // It fails with Promise<resolved:undefined> without this delay
    // But it does not add additionnal loading time (smaller chunks)
    setTimeout(this.initApplication, 500)
  },

  methods: {
    async initApplication () {
      try {
        await this.getApplication()
        await this.checkLicense()
        this.status = 'ready'
      } catch (e) {
        this.status = 'error'

        switch (e.message) {
          case 'version':
            this.error = 'version'
            break
          case 'license':
            this.error = 'license'
            break
          case 'gms':
            this.error = 'gms'
            break
        }
      }
    },

    // Get application definition
    getApplication () {
      return this.$store.dispatch('getApplication')
        .then(response => Promise.resolve(response))
        .catch(() => Promise.reject(new Error('gms')))
    },

    // Check the license is valid
    checkLicense () {
      // Prevent app to start if the license has an error
      // unless this error is related to max equipments / users
      if (this.application.license && !isEmpty(this.application.license.validError)) {
        if (this.application.license.validError.code.indexOf('LICENSE_MAXIMUM') === -1) {
          return Promise.reject(new Error('license'))
        }
      }

      return Promise.resolve()
    }
  }
}
</script>
